var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 19,
      height: 21
    },
    viewBox: "0 0 19 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M17.972 12.33 16.39 6.634a7.767 7.767 0 0 0-15.064.395L.099 12.541a4.166 4.166 0 0 0 4.067 5.07h.929a4.166 4.166 0 0 0 8.165 0h.699a4.166 4.166 0 0 0 4.014-5.28m-8.795 6.948a2.5 2.5 0 0 1-2.346-1.667h4.693a2.5 2.5 0 0 1-2.347 1.667m6.771-4.32a2.48 2.48 0 0 1-1.99.987H4.166a2.498 2.498 0 0 1-2.44-3.043L2.952 7.39a6.1 6.1 0 0 1 11.832-.31l1.584 5.696a2.48 2.48 0 0 1-.419 2.181"
  })));
};
export default SvgNotification;